import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DifficultyMeter from "../../gui/difficultyMeter";
import door from "../../res/rooms/COG_Image__00283_.png";
import doorSfx from "../../res/sfx/Walking_OneShot.wav";
import banner from "../../res/rooms/cog_tt_001.png";
import song from "../../res/music/Disorienting.mp3";
import {
  CAPDEPTH,
  changeSong,
  GetNextRooms,
  GetRoomObjectByName,
  GlobalContext,
  playOneShot,
} from "../room_handler";
import RandomRoomTreasure from "../../components/Loot";
import SkillCheckSelect from "../../components/SkillCheckSelect";
import { save } from "../../functions/save";
import { EntryPercResults, Perception } from "../../components/perception";

const bannerUrl = banner;
const doorUrl = door;

const Med_Hoard = () => {
  const InstanceVars = useContext(GlobalContext);
  const [nextRooms, changeNextRooms] = useState([]);
  const [toggleUnveil, changeToggleUnveil] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    changeSong(song);
    if (InstanceVars.current.nextRooms) {
      loadVals();
    } else {
      let nextRoomTemp = GetNextRooms(
        Med_Hoard_Obj,
        InstanceVars,
        Math.ceil(Math.random() * Med_Hoard_Obj.exits)
      );
      save(InstanceVars.current, Med_Hoard_Obj, nextRoomTemp);
      InstanceVars.current.score.depth += 100;
      changeNextRooms(nextRoomTemp);
    }
  }, [InstanceVars]);

  const loadVals = () => {
    let nextRoomTemp = [];
    InstanceVars.current.nextRooms.forEach((room) => {
      let tempRoom = GetRoomObjectByName(room.name);
      if (tempRoom) nextRoomTemp.push(tempRoom);
    });
    if (nextRoomTemp.length > 0) {
      delete InstanceVars.current.nextRooms;
      delete InstanceVars.current.currentRoom;
    } else {
      nextRoomTemp = GetNextRooms(
        Med_Hoard_Obj,
        InstanceVars,
        Math.ceil(Math.random() * Med_Hoard_Obj.exits)
      );
    }
    changeNextRooms(nextRoomTemp);
  };

  const submitHandler = (selection) => {
    selection.forEach((sel) => {
      if (sel.pass === true) changeToggleUnveil(true);
    });
  };

  return (
    <div className="room">
      <DifficultyMeter
        value={InstanceVars.current.depth}
        cap={CAPDEPTH}
        score={InstanceVars.current.score}
      />
      <h1>Treasure Chest</h1>
      <img className="banner" src={bannerUrl} />
      <p className="descriptionText">
        A small chest is hidden in the corner of the room. Stashed away by
        someone who clearly wanted to keep it hidden.
      </p>
      {!toggleUnveil ? (
        <>
          <p className="roomText">
            If you would like to attempt to open the chest, select a skill below
            and make a roll. Otherwise, feel free to continue.
          </p>
          <SkillCheckSelect
            options={[
              { method: "Athletics (body)", diffTier: 4, damTier: 0 },
              { method: "Stealth (dex)", diffTier: 2, damTier: 0 },
              { method: "Tinker (mind)", diffTier: 2, damTier: 0 },
            ]}
            noDamage
            specialEffect="You do not open the treasure chest"
            callback={submitHandler}
          />
        </>
      ) : (
        <RandomRoomTreasure chance={1} chanceForCurse={0.2} tier={2} />
      )}
      <Perception />
      <div className="nextHolder">
        {nextRooms.map((room, i) => {
          return room.entry(i, navigate);
        })}
      </div>
    </div>
  );
};

const Entryway = (i = 0, navigate) => {
  return (
    <button
      key={Med_Hoard_Obj.name + toString(i)}
      className="entry"
      onClick={() => {
        playOneShot(doorSfx);
        navigate(Med_Hoard_Obj.route);
      }}
    >
      <img src={Med_Hoard_Obj.image} />
      <span className="entryText">A dark cave leading into the unknown</span>
      <EntryPercResults
        observation={{
          tier: 4,
          text: "The path ahead is fairly undisturbed.",
        }}
        spirituality={{
          tier: 5,
          text: "You feel a hint of latent greed in this direction.",
        }}
      />
    </button>
  );
};

export var Med_Hoard_Obj = {
  name: "Med_Hoard",
  room: Med_Hoard,
  entry: Entryway,
  route: "/CityOfGold/med_hoard",
  exits: 2,
  prob: 3,
  image: doorUrl,
};

export default Med_Hoard;
